import { render, staticRenderFns } from "./BeneficiaryListComponent.vue?vue&type=template&id=608c0272"
import script from "./BeneficiaryListComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiaryListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports